import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'

// Use individual selectors to prevent unnecessary re-renders
// Each selector only triggers re-render when its specific value changes
const selectUser = (s: ReturnType<typeof useAuthStore.getState>) => s.user
const selectSession = (s: ReturnType<typeof useAuthStore.getState>) => s.session
const selectLoading = (s: ReturnType<typeof useAuthStore.getState>) => s.loading
const selectInitialize = (s: ReturnType<typeof useAuthStore.getState>) => s.initialize
const selectSignInWithPassword = (s: ReturnType<typeof useAuthStore.getState>) => s.signInWithPassword
const selectSignInWithGitHub = (s: ReturnType<typeof useAuthStore.getState>) => s.signInWithGitHub
const selectSignInWithAzure = (s: ReturnType<typeof useAuthStore.getState>) => s.signInWithAzure
const selectSignOut = (s: ReturnType<typeof useAuthStore.getState>) => s.signOut

export function useAuth() {
  const user = useAuthStore(selectUser)
  const session = useAuthStore(selectSession)
  const loading = useAuthStore(selectLoading)
  const initialize = useAuthStore(selectInitialize)
  const signInWithPassword = useAuthStore(selectSignInWithPassword)
  const signInWithGitHub = useAuthStore(selectSignInWithGitHub)
  const signInWithAzure = useAuthStore(selectSignInWithAzure)
  const signOut = useAuthStore(selectSignOut)

  useEffect(() => {
    initialize()
  }, [initialize])

  return {
    user,
    session,
    loading,
    signInWithPassword,
    signInWithGitHub,
    signInWithAzure,
    signOut,
  }
}
